<template>
  <div class="quick-bet-page">
    <div style="width: 890px">
      <div style="max-height: 550px; overflow-y: auto">
        <table class="quick-table" cellpadding="0" cellspacing="0">
          <colgroup>
            <col width="100" />
            <col width="150" />
            <col width="80" />
            <col width="80" />
            <col width="80" />
            <col width="80" />
            <col width="80" />
            <col width="150" />
          </colgroup>
          <thead>
            <tr>
              <th>彩种</th>
              <th>注单编号</th>
              <th>号码</th>
              <th>赔率</th>
              <th>金额</th>
              <th>回水</th>
              <th>状态</th>
              <th style="position: relative">
                <el-checkbox class="checkbox dark" v-model="checkAll">
                  全选
                </el-checkbox>
                <input
                  class="btn primary"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 5px;
                    transform: translateY(-50%);
                    font-size: 12px;
                  "
                  type="button"
                  @click="chargeback()"
                  value="退码"
                />
              </th>
            </tr>
          </thead>
          <tbody v-if="list.length == 0">
            <tr>
              <td colspan="8" style="background: transparent; height: 320px">
                <div class="noData"></div>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="list.length < 10">
            <tr
              v-for="(item, index) in list"
              :class="{ charge: item.ispei == 2 }"
              :key="index"
            >
              <td>河内时时彩</td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.betNumber }}</td>
              <td class="active-text bold">
                {{ (item.peilv * 1).toFixed(1) }}
              </td>
              <td>{{ (item.money * 1).toFixed(2) }}</td>
              <td>{{ item.back }}</td>
              <td>
                {{
                  item.ispei == "-"
                    ? "-"
                    : item.ispei == 0
                    ? "成功"
                    : item.ispei == 1
                    ? "已赔"
                    : item.ispei == 2
                    ? "退码"
                    : item.ispei == 3
                    ? "停码"
                    : "和"
                }}
              </td>
              <td>
                <span v-if="item.ispei == 2">--</span>
                <el-checkbox class="checkbox" v-model="item.checked" />
                <!-- <input v-else v-model="item.checked" type="checkbox" name id /> -->
              </td>
            </tr>
            <tr v-for="item in 10 - list.length" :key="item + '-label'">
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              :class="{ charge: item.ispei == 2 }"
              v-for="(item, index) in list"
              :key="index"
            >
              <td>河内时时彩</td>
              <td>{{ item.orderId }}</td>
              <td>{{ item.betNumber }}</td>
              <td class="red">{{ (item.peilv * 1).toFixed(1) }}</td>
              <td>{{ (item.money * 1).toFixed(2) }}</td>
              <td>{{ item.back }}</td>
              <td>
                {{
                  item.ispei == "-"
                    ? "-"
                    : item.ispei == 0
                    ? "成功"
                    : item.ispei == 1
                    ? "已赔"
                    : item.ispei == 2
                    ? "退码"
                    : item.ispei == 3
                    ? "停码"
                    : "和"
                }}
              </td>
              <td>
                <span v-if="item.ispei == 2">--</span>
                <el-checkbox class="checkbox" v-model="item.checked" />
                <!-- <input v-else v-model="item.checked" type="checkbox" name id /> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="bottom-tool">
        <div class="title">
          快打
          <!-- <el-checkbox class="checkbox dark white-text" v-model="checkAll">
            全选
          </el-checkbox> -->
        </div>
        <div class="content">
          <div class="left">
            <div>
              <span class="info-text bold">号码：</span>
              <el-popover
                placement="bottom"
                width="200"
                trigger="manual"
                content="输入号码有误"
                v-model="visible"
              >
                <input
                  class="input"
                  type="text"
                  slot="reference"
                  v-model="number"
                  @input="numberChange($event)"
                  maxlength="5"
                  placeholder="任意字符=X"
                />
              </el-popover>
            </div>
            <div>
              <span class="active-text bold">下注金额：</span>
              <input
                class="input"
                type="text"
                ref="money"
                oninput="value=value.replace(/[^\d | ^.]/g,'').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"
                @keyup.enter="submit()"
                v-model="money"
              />
            </div>
            <div>
              <input
                class="btn primary"
                type="button"
                value="提交"
                @click="submit()"
              />
            </div>
          </div>
          <div class="right" v-show="betVisible">
            <div style="margin-right: 20px">
              <span>赔率：</span>
              <span
                class="bold"
                style="display: inline-block; color: #619fe8"
                >{{ odds }}</span
              >
            </div>
            <div style="margin-right: 20px">
              <span>可下：</span>
              <span class="bold active-text" style="display: inline-block">{{
                maxCount
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkAll: false,
      visible: false,
      betVisible: false,
      maxCount: "",
      odds: "",
      number: "",
      money: "",
      list: [],
    };
  },
  props: ["initFinished", "isClose"],
  mounted() {
    this.initData();
  },
  watch: {
    initFinished() {
      this.initData();
    },
    checkAll(newVal) {
      this.list.forEach((item) => {
        this.$set(item, "checked", newVal);
      });
      // this.list = JSON.parse(JSON.stringify(this.list));
    },
  },
  methods: {
    initData() {
      this.getList();
      this.getOpenLit();
    },
    async numberChange(e) {
      this.number = e.target.value.replace(/[^\d]/g, "X");
      if (this.number.length == 5) {
        if (
          this.number.replace(/\D/g, "").length > 0 &&
          this.number.replace(/\D/g, "").length < 5
        ) {
          this.$refs.money.focus();

          let data = {
            access_token: this.$store.state.userInfo.access_token,
            uid: this.$store.state.userInfo.uid,
            game_code: this.$store.state.gameInfo[0].code,
            bet_str: this.number,
          };

          let result = await this.$http.postAxiosMethod(
            "/user/kuaidaodds",
            data
          );
          if (result.code == 0) {
            this.maxCount = result.data.maxCount;
            this.odds = result.data.odds;
            this.betVisible = true;
          }
        } else {
          this.visible = true;
          this.number = "";
          setTimeout(() => {
            this.visible = false;
          }, 1000);
        }
      } else {
        this.betVisible = false;
      }
    },
    async chargeback() {
      let orderSubIds = [];
      this.list.forEach((item) => {
        if (item.checked) {
          orderSubIds.push(item.orderSubId);
        }
      });
      orderSubIds = orderSubIds.join(",");
      if (orderSubIds != "") {
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          code: this.$store.state.gameInfo[0].code,
          qihao: this.$store.state.gameInfo[0].nextQihao,
          orderSubIds,
        };
        let result = await this.$http.postAxiosMethod("/user/chargeback", data);
        if (result.code == 0) {
          this.$message({
            message: result.msg,
            type: "success",
          });
          setTimeout(() => {
            this.$BUS.$emit("bet");
          }, 500);
          this.getList();
        }
      }
    },
    async submit() {
      if (this.isClose == 0) {
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          game_code: this.$store.state.gameInfo[0].code,
          play_type: "",
          key: new Date().getTime(),
          play_type: "kuaida",
          bet_money: this.money,
          total_money: this.money,
          bet_num: "1",
          bet_str: this.number,
          bet_log: "游戏日志",
          bet_qihao: this.$store.state.gameInfo[0].nextQihao,
        };
        let result = await this.$http.postAxiosMethod("/user/bet", data);
        if (result.code == 0) {
          this.$message({
            iconClass: "fa fa-check-circle",
            customClass: "bet_message",
            type: "success",
            duration: 3000,
            message: "下注成功！",
          });
          this.number = "";
          this.money = "";
          this.getList();
          setTimeout(() => {
            this.$BUS.$emit("bet");
          }, 500);
        }
      } else {
        document.activeElement.blur();
        this.$alert("已封盘", "提示");
      }
    },

    async getList() {
      if (this.initFinished) {
        let access_token = this.$store.state.userInfo.access_token;
        let uid = this.$store.state.userInfo.uid;
        let game_code = this.$store.state.gameInfo[0].code;
        let data = {
          access_token,
          uid,
          game_code,
        };
        let result = await this.$http.postAxiosMethod(
          "/user/currentissuebetlist",
          data
        );
        if (result.code == 0) {
          this.list = result.data;
          this.list.forEach((item) => {
            this.$set(item, "checked", false);
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quick-bet-page {
  width: 890px;
  display: flex;
  .charge {
    background-color: rgb(255, 193, 132) !important;
  }
  .quick-table {
    width: 100%;
    font-size: 12px;
    background: var(--new-bg-white);
    thead {
      tr {
        background: var(--new-bg-table-header-main);
        th {
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          color: var(--new-text-info);
          text-align: left;
        }
      }
    }
    tbody {
      tr {
        // &:nth-child(n) {
        //   background: #fff;
        // }
        // &:nth-child(2n) {
        //   background: #f0f0f0;
        // }
        td {
          padding: 0 20px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          border-bottom: 1px solid var(--new-border);
        }
      }
    }
  }
  .bottom-tool {
    margin: 0;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    background: #fff;
    .title {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      background: var(--new-primary-color);
      font-size: 12px;
      color: #fff;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      height: 50px;
      .left {
        display: flex;
        align-items: center;
        & > div {
          margin-right: 20px;
        }
      }
      .right {
        display: flex;
        align-items: center;
      }
      input[type="text"] {
        text-align: left;
        width: 100px;
        height: 25px;
        border: 1px solid var(--new-border);
        font-size: 13px;
        padding: 5px;
      }
    }
  }
}
</style>
